import React from 'react';

/** Lightbulb / tip icon; inherits color via `currentColor`. */
const LightbulbIcon: React.FC<{ className?: string }> = ({ className = '' }) => (
  <svg
    className={className}
    width="18"
    height="18"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden
  >
    <path
      d="M9 18h6M10 21h4M12 3a6 6 0 0 0-3.6 10.8c.5.4.8.9 1 1.5l.2.7h4.8l.2-.7c.2-.6.5-1.1 1-1.5A6 6 0 0 0 12 3z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default LightbulbIcon;
